var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx-login-callback"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('el-alert',{attrs:{"title":"正在处理微信登录...","type":"info","closable":false,"show-icon":""}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }